/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "CaBusiness": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "gstHstNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "qstNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": ".squareup.onboarding.business.CaBusiness.Type",
                    "id": 7,
                    "rule": "optional"
                  },
                  "registeredAddressToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "registeredAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 11,
                    "rule": "optional"
                  },
                  "runVerificationAfter": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "businessRegistrationNumber": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "mobileBusiness": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "tradingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 15,
                    "rule": "optional"
                  },
                  "federalBusinessNumber": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "registeredCharity": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "acceptsPublicDonations": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "BUSINESS": 1,
                      "INDIVIDUAL": 2,
                      "PARTNERSHIP": 3,
                      "CHARITABLE_NON_PROFIT": 4,
                      "PUBLIC_COMPANY": 5,
                      "OTHER": 6,
                      "COMPANY": 7,
                      "KYB_LIMITED_COMPANY": 8,
                      "KYB_LIMITED_LIABILITY_COMPANY": 9,
                      "KYB_PARTNERSHIP": 10,
                      "KYB_PUBLIC_COMPANY": 11,
                      "KYB_OTHER": 12,
                      "KYB_COMPANY": 13,
                      "KYB_CHARITABLE_NON_PROFIT": 14
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.CaBusiness && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.CaBusiness?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in Canada.
 *
 * SOURCE CaBusiness @ squareup/onboarding/business/ca.proto at 12:1
 */
export const CaBusiness = $root.lookupType('squareup.onboarding.business.CaBusiness');
fixType(CaBusiness);
Builder.createAndAttachToType(CaBusiness);
/**
 * SOURCE Type @ squareup/onboarding/business/ca.proto at 32:3
 */
CaBusiness.Type = $root.lookupEnum('squareup.onboarding.business.CaBusiness.Type').values;